import useCreditApplications from "hooks/donations/useCreditApplications";
import useFormattedDate from "hooks/useFormatDate";
import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { ApprovalModal } from "./ApprovalModal";
import useDonationsPurposes from "hooks/donations/useDonationPurposes";
import { HeaderSection } from "../sections/HeaderSection";
import UserInfoSection from "../sections/UserInfoSection";
import AdditionalInfoSection from "../sections/AdditionalInfoSection";
import ReferencesSection from "../sections/ReferencesSection";
import FilesSection from "../sections/FilesSection";
import { PurposesTable } from "../sections/PurposesTable";
import { ApplicationCreditsTable } from "../sections/ApplicationCreditsTable";

export const ApplicationDetails = () => {
  const { applicationId } = useParams();
  const navigate = useNavigate();

  const [application, setApplication] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState(null);

  const { loading, fetchCreditApplicationById, error } =
    useCreditApplications();
  const { donationPurposes: allPurposes, loading: purposesLoading } =
    useDonationsPurposes();
  const { formatDateTime } = useFormattedDate();

  useEffect(() => {
    const fetchCreditApplication = async () => {
      if (!applicationId) return;
      try {
        const data = await fetchCreditApplicationById(applicationId);
        setApplication(data);
      } catch (err) {
        setApplication(null);
      }
    };
    fetchCreditApplication();
  }, [applicationId]);

  // destruction the credit value details
  const {
    id,
    user,
    status,
    contactInfo,
    createdAt,
    updatedAt,
    description,
    passportPhoto,
    documents,
    photos,
    references,
    purposeIds,
    credits,
    actions,
  } = application || {};

  // Filter only purposes whose IDs exist in the application's purposeIds array
  const creditAppPurposes =
    allPurposes?.filter((purpose) => purposeIds?.includes(purpose.id)) || [];

  if (loading && !application) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: 400 }}
      >
        <Spinner animation="border" variant="success" />
        <span className="ms-3" style={{ fontSize: "13.33px" }}>
          Loading...
        </span>
      </div>
    );
  }

  return (
    <>
      <HeaderSection
        navigate={navigate}
        status={status}
        id={id}
        setShowModal={setShowModal}
        setActionType={setActionType} 
      />

      <Row className="g-4">
        <Col lg={4} className="mb-3">
          <UserInfoSection
            user={user}
            contactInfo={contactInfo}
            passportPhoto={passportPhoto}
          />
        </Col>

        <Col lg={4} className="mb-3">
          <AdditionalInfoSection
            status={status}
            createdAt={createdAt}
            updatedAt={updatedAt}
            description={description}
            formatDateTime={formatDateTime}
          />
          <ReferencesSection references={references} />
        </Col>

        <Col lg={4} className="mb-3  ps-3">
          <FilesSection photos={photos} />
        </Col>

        <Col lg={12}>
          <PurposesTable
            purposes={creditAppPurposes}
            title="Application purposes"
          />
        </Col>

        <Col lg={12} className="mt-4">
          <ApplicationCreditsTable credits={credits} status={status} />
        </Col>
      </Row>

      {/* Approval modal */}
      <ApprovalModal
        showModal={showModal}
        setShowModal={setShowModal}
        creditAppId={id}
        actionType={actionType}
        onActionSuccess={(updatedData, type) => {
          setApplication((prev) => {
            let newStatus = prev.status;

            if (type === "APPROVE") newStatus = "APPROVED";
            if (type === "DENY") newStatus = "DENIED";
            if (type === "CANCEL") newStatus = "CLOSED";

            return {
              ...prev,
              status: newStatus,
              actions: [...(prev?.actions || []), updatedData],
            };
          });
        }}
        
      />
    </>
  );
};
